import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

function CreateTrainingForm() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const navigate = useNavigate();
  const usernameRef = useRef(null);

  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async () => {
    try {
      const response = await fetch(`${baseURL}/createTraining`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormData(null);
        setShowModal(false);
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/listelement");
        }, 3000);

        // window.location.href = "/listelement";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          trainingname: "",
          duration: "",
        }}
        validationSchema={Yup.object({
          trainingname: Yup.string().required("Trainingname is required"),
          duration: Yup.string().required("Duration is required"),
        })}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form noValidate onSubmit={handleSubmit}>
            <div className="container">
              <h4 className="text-start  pb-2">CREATE TRAINING</h4>
              <div className="col-lg-12  mt-1 m-5">
                <div className="row">
                  <div className="col-lg-5 ">
                    <label className="formlabel">
                      Training Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.trainingname && errors.trainingname
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter training name--"
                      name="trainingname"
                      value={values.trainingname}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.trainingname && errors.trainingname ? (
                      <div className="text-danger">{errors.trainingname}</div>
                    ) : null}
                  </div>
                  <div class="col-lg-5  ml-5">
                    <label>Duration</label>
                    <br />
                    <input
                      type="time"
                      className="form-control"
                      placeholder="enter duration"
                      min={0}
                      name="duration"
                      onChange={handleChange}
                      value={values.duration}
                    ></input>
                  </div>
                </div>
                <div className="col-lg-11 text-end mt-5 pb-3">
                  <button
                    type="submit"
                    className="border-0 mt-3 p-1 savebtn fst-normal"
                  >
                    Save
                  </button>
                  <a href="/listelement" className="text-decoration-none ">
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <div className="col-lg-12">
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do You Want to Confirm the changes?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConfirmSubmit}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>
  );
}

export default CreateTrainingForm;
